export const EventType = {
  BREAK: 'BREAK',
  START: 'START',
  END: 'END',
};
